import { AdditionalItems, IAdditionalItems } from './AdditionalItems';

interface OptionalAdditionalItemsProps extends Required<Omit<IAdditionalItems, 'isMandatory'>> {}

export const OptionalAdditionalItems = (props: OptionalAdditionalItemsProps) => {
  return <AdditionalItems {...props} />;
};
